import React, { useEffect, useMemo, useState } from 'react';

import useDisabledUsers from 'hooks/useDisabledUsers';
import { getObjectiveLocale } from 'utils/HelperUtils';
import { getObjectiveInvolvements } from 'utils/ObjectivesHelper';

import InlineDialogSelectUser from 'components/inline-dialog/InlineDialogSelectUser';
import { getNewInvolvements } from 'components/sidebar/sidebar-create/SidebarCreateHelper';

const Reviewer = ({ objectiveValue, setObjectiveValue, updateObjective }) => {
  const { permissions, involvements } = objectiveValue;

  const { checkIsUserDisabled } = useDisabledUsers({
    isEdit: true,
    isProject: true,
    objective: objectiveValue
  });

  const currentInvolvements = useMemo(() => {
    return [...involvements];
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [isRemoveIconClicked, setIsRemoveIconClicked] = useState(false);

  const selectedReviewer = getObjectiveInvolvements(involvements, 'reviewer');
  const selectedOwner = getObjectiveInvolvements(involvements, 'assignee');

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const handleChangeDialog = (involvements, type) => {
    const lastIndex = involvements?.length - 1;
    const selectedUser = involvements[lastIndex];

    checkIsUserDisabled(selectedUser?.user?.id, () => {
      let newInvolvements = getNewInvolvements(
        involvements,
        type,
        false,
        objectiveValue,
        null,
        null,
        true
      );

      setObjectiveValue((draft) => {
        draft.involvements = newInvolvements;
      });
    });
  };

  const updateReviewer = async () => {
    const newInvolvements = objectiveValue.involvements.map((involvement) => ({
      userId: involvement.user.id,
      role: involvement.role,
      placementId: involvement.user.placementId,
      extendedRole: involvement.extendedRole
    }));

    const { isSuccess } = await updateObjective({
      involvements: newInvolvements
    });

    if (!isSuccess) {
      setObjectiveValue((draft) => {
        draft.involvements = currentInvolvements;
      });
    }
  };

  const removeUserCallback = () => {
    // ** If user click remove icon dialog
    // ** setIsRemoveIconClicked to true, to trigger useEffect to update reviewer
    setIsRemoveIconClicked(true);

    // ** Reset state
    setTimeout(() => {
      setIsRemoveIconClicked(false);
    }, 50);
  };

  useEffect(() => {
    // ** To update reviewer when the remove icon was clicked
    if (isRemoveIconClicked) {
      updateReviewer();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isRemoveIconClicked]);

  return (
    <div className="w-1/2">
      <p className="typography-h100 text-n-800">
        {getObjectiveLocale('Reviewer')}
      </p>
      <div className="ml-[-8px]">
        <InlineDialogSelectUser
          objectiveValue={objectiveValue}
          selectedValue={selectedReviewer}
          handleChange={handleChangeDialog}
          permission={permissions?.includes('assign_reviewer')}
          selectedOwner={selectedOwner}
          type="assigner"
          position="right"
          header="Reviewer"
          onCloseDialog={updateReviewer}
          dataCy="inline-dialog-project-reviewer"
          removeUserCallback={removeUserCallback}
        />
      </div>
    </div>
  );
};

export default Reviewer;
